import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Tooltip, OverlayTrigger  } from 'react-bootstrap'

import ReportTableRowValues from 'modules/Charts/ReportTableRow/ReportTableRowValues'
import APPURL from 'utils/app/urls'
import IndicatorTools from 'utils/indicators/indicatorTools'

import messages from './messages'


class ReportTableRowContainer extends Component {
	constructor(props) {
		super(props)

		const {
			intl: { formatNumber, formatMessage }
		} = props

		this.formatNumber = formatNumber;
		this.formatMessage = formatMessage;

		this.state = {
			"lastCommonYear": "",
			"mostRecentYear": ""
		}
		this.allRegionsChartRef = React.createRef()
		this.referenceRegionsChartRef = React.createRef()
		this.sameCountryRegionsChartRef = React.createRef()

		this.unit = this.getUnit(props.indicatorsData)

		// var updateTime = this.updateTime.bind( this );
	}

	componentDidMount() {
		this.setState( {'loading': true} );
	}

	getUnit = indicatorsData => {
		const indicator_id = this.props.indicator;
		const indicatorData = indicatorsData.filter(item => item.id === indicator_id)[0];
		const unit = indicatorData ? indicatorData.unit : "n.d.";

		return unit
	}

	renderValues() {
		let renderingComponentALL = null;
		let comparative = null;

		const indicatorData = this.props.indicatorsData.filter(item => item.id === this.props.indicator)[0]

		if (this.props.otherRegionsFilter !== undefined && this.props.otherRegionsFilter.length !== 0) {
			comparative = this.props.otherRegionsFilter[0]
		}

		let topLevelRegions = {
			"ctry": this.props.selectedRegionCountryMeta.id,
			"eu": this.props.allRegionsGroupRegionId
		};

		renderingComponentALL = (
			<ReportTableRowValues
				key={"values"}
				regionsData={JSON.stringify(this.props.regionsData)}
				indicator={this.props.indicator}
				indicatorData={indicatorData}
				precision={this.props.precision}
				unit={this.unit}
				selectedRegionId={this.props.selectedRegionId}
				comparative={comparative}
				config={'allRegions'}
				topLevelRegions={topLevelRegions}
				updateTime={this.updateTime.bind(this)}
				sendDataUp={this.props.sendDataUp}
				ignoreColor={this.props.ignoreColor}
			/>
		)


		return (
			<React.Fragment>
				{renderingComponentALL}
			</React.Fragment>
		)
	}

	updateTime( lastCommonYear, mostRecentYear ) {
		this.setState({
			"lastCommonYear": lastCommonYear,
			"mostRecentYear": mostRecentYear
		});
	}

	getInfoNote(notetext, sourcetext) {
		let noteLine = null;
		let noteIconClass = "fal fa-info-circle";
		if ( notetext ) {
			noteLine = <React.Fragment>
				<p><small><strong className="note-warning">{this.formatMessage( messages.dataNote )}</strong>: {notetext}</small></p>
				</React.Fragment>;
			noteIconClass = "fal fa-info-circle note-warning";
		}
		let noteTooltip = <Tooltip id="tooltip" className='tooltip-note'>
			{noteLine}
			<p><small><strong>{this.formatMessage( messages.dataSource )}</strong>: {sourcetext}</small></p>
			</Tooltip>;

		return (
			<React.Fragment>
				<OverlayTrigger overlay={noteTooltip} placement="top">
					<Link to="#" className="float-right"><i className={noteIconClass}></i></Link> 
				</OverlayTrigger>
			</React.Fragment>
		);

		// info-circle ?
	}

	renderIfAllOK() {
		const indicatorData = this.props.indicatorsData.filter(item => item.id === this.props.indicator)[0];
		const indicatorName = IndicatorTools.cleanIndicatorName( indicatorData.name );
		const indicatorUnit = IndicatorTools.cleanIndicatorUnit( indicatorData.unit );
		const indicatorNote = indicatorData.note;
		const indicatorSource = indicatorData.dataSource;
		const actualURL = this.props.history.location.pathname;
		const indicatorDetailUrl = APPURL.getIndicatorDetailLinkEx({ url: actualURL, indicator: indicatorData.id })

		let infoFragment = this.getInfoNote( indicatorNote, indicatorSource );
		
		return (
			<div className="row report-table-row">
				<div className="col-lg-7">
					<div className="report-indicator-note">{infoFragment}</div>
					<div className="report-indicator-title">
						<Link to={indicatorDetailUrl}>{indicatorName}</Link>
						<p className="report-indicator-unit visible-lg">({indicatorUnit})</p>
						<p className="report-indicator-year hidden-lg">{this.state.mostRecentYear}</p>
					</div>
				</div>
				<div className="col-lg-5">
					{this.renderValues()}
				</div>
			</div>
		)
	}

	render() {
		return this.renderIfAllOK();
	}
}

export default injectIntl(ReportTableRowContainer)



// WEBPACK FOOTER //
// ./src/modules/Charts/ReportTableRow/ReportTableRowContainer/ReportTableRowContainer.jsx